import { Divider, Form } from 'antd';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import InsurerGeneralForm from '@/components/Insurers/InsurerGeneralForm';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import { useServiceError } from '@/hooks';
import { useCreateInsurer } from '@/core/domain/people/Insurers/Insurers.hooks';
import { PageProps } from '@/types/PageProps';
import { InsurerFormValues } from '@/core/domain/people/Insurers/Insurers.types';
import Authorities from '@/types/Authority';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';

const CreateInsurerPage = ({ route }: PageProps) => {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<InsurerFormValues>();

  const mutation = useCreateInsurer();

  useServiceError(mutation.error);

  const handleSaveClick = async () => {
    const values = await form.validateFields();

    const obj = { ...values, active: true };

    const result = await mutation.mutateAsync(obj);

    history.push(`/app/registry/insurers/${result.id}`);
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSaveClick}
          loading={mutation.isLoading}
          disabled={!hasPermissions([Authorities.REGISTER_INSURER_ADD])}
        >
          {intl.formatMessage({ id: 'commons.form.button.save' })}
        </SaveButton>
      }
    >
      <InsurerGeneralForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/registry/insurers" />
      </SpaceForButton>
    </TabContentWrapper>
  );
};

export default CreateInsurerPage;
